import React from 'react';
import { Card, Props as CardProps } from '../../Atoms/Card';
import { Flex } from '../../Atoms/Flex';
import { FontIcon } from '../../Atoms/FontIcon';
import { Transition } from '../../Atoms/Transition';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from '@mui/material/styles';

export interface Props extends CardProps {
  header: React.ReactNode;
  isExpanded: boolean;
  children: React.ReactElement;
  onCardClick: () => void;
}

const ExpandableCardComponent: React.FC<Props> = (
  props: Props
): JSX.Element => {
  const { header, isExpanded, children, onCardClick, ...cardProps } = props;
  const theme = useTheme();
  return (
    <Card
      {...cardProps}
      dataTest="expandablecard-molecule"
      onClick={onCardClick}
      hoverBackground={theme.palette.action.hover}
      style={{ cursor: 'pointer' }}
    >
      <Flex alignItems="center">
        {header}
        {isExpanded && (
          <FontIcon
            ml="auto"
            icon={faChevronUp}
            color={theme.palette.text.primary}
          />
        )}
        {!isExpanded && (
          <FontIcon
            ml="auto"
            icon={faChevronDown}
            color={theme.palette.text.primary}
          />
        )}
      </Flex>
      <Transition variant="collapse" show={isExpanded}>
        {children}
      </Transition>
    </Card>
  );
};

ExpandableCardComponent.displayName = 'ExpandableCard';

export const ExpandableCard = ExpandableCardComponent;
